var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18H15V33H22.5V18Z",
    stroke: "#1B2559",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14.25H22.5V33H33V14.25Z",
    stroke: "#1B2559",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22.5V24",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27V28.5",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 18.75V20.25",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18.75V20.25",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/Companies.678b62efeb54630ce27bfbbac697a628.svg";
export { ForwardRef as ReactComponent };